/* Interactive Feeding Guide (CLAUDE.md §5, revised). One card; feedings/day is
   the headline metric, g/day secondary. Single all-purpose formula (no food type). */
(function () {
  'use strict';
  var root = document.querySelector('[data-feeding-guide]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(root.querySelector('[data-feeding-config]').textContent); } catch (e) { return; }
  var reduce = (window.Koi && window.Koi.reduceMotion);
  var fmtMoney = (window.KoiCart && window.KoiCart.format) || function (c) { return '$' + (c / 100).toFixed(2); };

  // Average size -> approx live weight (grams).
  var SIZES = [{ g: 90 }, { g: 600 }, { g: 2000 }, { g: 4500 }];
  var B = cfg.boundaries;

  // Status-label color mimics the temperature slider's gradient at the current point.
  var rootStyle = getComputedStyle(document.documentElement);
  function hexToRgb(h) {
    h = String(h).trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }
  function cssVar(name, fallback) { var v = rootStyle.getPropertyValue(name); return hexToRgb(v && v.trim() ? v : fallback); }
  var GRAD = [
    { p: 0.00, c: cssVar('--blue-600', '#1C90E3') },
    { p: 0.26, c: cssVar('--blue-400', '#71B4E5') },
    { p: 0.52, c: [95, 179, 137] },
    { p: 0.80, c: cssVar('--koi-orange', '#E8732A') },
    { p: 1.00, c: cssVar('--koi-red', '#C7312A') }
  ];
  function sliderColor(frac) {
    frac = Math.max(0, Math.min(1, frac));
    for (var i = 1; i < GRAD.length; i++) {
      if (frac <= GRAD[i].p) {
        var a = GRAD[i - 1], b = GRAD[i], t = (frac - a.p) / (b.p - a.p || 1);
        return 'rgb(' + Math.round(a.c[0] + (b.c[0] - a.c[0]) * t) + ',' +
          Math.round(a.c[1] + (b.c[1] - a.c[1]) * t) + ',' +
          Math.round(a.c[2] + (b.c[2] - a.c[2]) * t) + ')';
      }
    }
    return 'rgb(' + GRAD[GRAD.length - 1].c.join(',') + ')';
  }

  function band(tF) {
    if (tF < B[0]) return { label: 'Dormant', factor: 0.0, times: 'Skip', season: 'Winter. Digestion nearly stops.', tone: 'bad' };
    if (tF < B[1]) return { label: 'Cool Water', factor: 0.25, times: '1', season: 'Early spring or late autumn.', tone: 'warn' };
    if (tF < B[2]) return { label: 'Warming Up', factor: 0.5, times: '1–2', season: 'Spring. Metabolism rising.', tone: 'good' };
    if (tF < B[3]) return { label: 'Optimal Growth', factor: 1.0, times: '2–4', season: 'Summer. Peak appetite and growth.', tone: 'good' };
    if (tF < B[4]) return { label: 'Warm', factor: 0.6, times: '2–3', season: 'Hot spell. Feed the cooler hours.', tone: 'warn' };
    return { label: 'Reduce', factor: 0.3, times: '1–2', season: 'Very warm. Water holds less oxygen.', tone: 'bad' };
  }

  var variants = (cfg.variants || []).map(function (v) {
    var m = String(v.title).match(/([\d.]+)\s*lb/i);
    return { id: v.id, title: v.title, label: m ? (m[1] + ' lb') : v.title, price: v.price, available: v.available, g: m ? parseFloat(m[1]) * 453.592 : null };
  }).filter(function (v) { return v.g; }).sort(function (a, b) { return a.g - b.g; });

  var state = { count: cfg.defaultCount || 6, sizeIdx: 1, tempF: cfg.defaultTempF || 68, unit: cfg.unitDefault || 'F' };

  var el = {
    count: root.querySelector('[data-fg-count]'),
    temp: root.querySelector('[data-fg-temp]'),
    tempVal: root.querySelector('[data-fg-temp-val]'),
    season: root.querySelector('[data-fg-season]'),
    result: root.querySelector('[data-fg-result]'),
    mode: root.querySelector('[data-fg-mode]'),
    feedings: root.querySelector('[data-fg-feedings]'),
    feedingsSub: root.querySelector('.kg-fg__feedings-sub'),
    grams: root.querySelector('[data-fg-grams]'),
    rec: root.querySelector('[data-fg-rec]'),
    cta: root.querySelector('[data-fg-cta]')
  };
  var recommended = null;

  function fToC(f) { return (f - 32) * 5 / 9; }
  function durationText(weeks) {
    if (weeks >= 1.5) { var w = Math.round(weeks); return w + (w === 1 ? ' week' : ' weeks'); }
    var days = Math.max(1, Math.round(weeks * 7));
    return days + (days === 1 ? ' day' : ' days');
  }

  function compute() {
    var bio = state.count * SIZES[state.sizeIdx].g;
    var bd = band(state.tempF);
    var gday = bio * (cfg.peakPct / 100) * bd.factor;
    var rec = null, recWeeks = null;
    if (variants.length) {
      if (gday <= 0) { rec = variants[0]; }
      else {
        var withWeeks = variants.map(function (v) { return { v: v, wk: v.g / gday / 7 }; });
        var ok = withWeeks.filter(function (x) { return x.wk <= cfg.freshnessWeeks; });
        rec = ok.length ? ok[ok.length - 1].v : withWeeks[0].v;
        recWeeks = rec.g / gday / 7;
      }
    }
    return { gday: gday, band: bd, rec: rec, recWeeks: recWeeks };
  }

  var lastGrams = 0;
  function animateGrams(to) {
    to = Math.round(to);
    if (reduce || !window.gsap) { el.grams.textContent = to; lastGrams = to; return; }
    var o = { v: lastGrams };
    window.gsap.to(o, { v: to, duration: 0.5, ease: 'power2.out', onUpdate: function () { el.grams.textContent = Math.round(o.v); } });
    lastGrams = to;
  }

  function render() {
    var r = compute();
    el.mode.textContent = r.band.label;
    var tmin = parseFloat(el.temp.min) || 40, tmax = parseFloat(el.temp.max) || 95;
    el.mode.style.color = sliderColor((state.tempF - tmin) / (tmax - tmin));
    var times = r.gday > 0 ? r.band.times : 'Skip';
    el.feedings.innerHTML = times.replace('–', '<span class="kg-fg__dash">&ndash;</span>');
    if (el.feedingsSub) el.feedingsSub.textContent = r.gday > 0 ? 'feedings per day' : 'feeding for now';
    animateGrams(r.gday);
    if (el.season) el.season.textContent = r.band.season;

    recommended = r.rec;
    if (r.rec) {
      if (r.gday <= 0) {
        el.rec.innerHTML = 'Koi are dormant. A ' + r.rec.label + ' bag will easily last the cold season.';
      } else {
        el.rec.innerHTML = 'A ' + r.rec.label + ' bag lasts about <b>' + durationText(r.recWeeks) + '</b> for your setup.';
      }
      el.cta.textContent = 'Get the ' + r.rec.label + ' bag, ' + fmtMoney(r.rec.price);
    } else {
      el.rec.textContent = '';
      el.cta.textContent = 'Choose your size';
    }
  }

  function setTempDisplay() {
    el.tempVal.textContent = state.unit === 'F' ? Math.round(state.tempF) + '°F' : Math.round(fToC(state.tempF)) + '°C';
  }

  el.count.addEventListener('input', function () {
    var n = parseInt(el.count.value, 10); state.count = isNaN(n) ? 1 : Math.min(200, Math.max(1, n)); render();
  });
  root.querySelectorAll('[data-fg-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.count = Math.min(200, Math.max(1, state.count + parseInt(b.getAttribute('data-fg-step'), 10)));
      el.count.value = state.count; render();
    });
  });
  root.querySelectorAll('[data-fg-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.sizeIdx = parseInt(b.getAttribute('data-fg-size'), 10);
      root.querySelectorAll('[data-fg-size]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true'); render();
    });
  });
  el.temp.addEventListener('input', function () { state.tempF = parseFloat(el.temp.value); setTempDisplay(); render(); });
  root.querySelectorAll('[data-fg-unit]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.unit = b.getAttribute('data-fg-unit');
      root.querySelectorAll('[data-fg-unit]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      setTempDisplay();
    });
  });

  el.cta.addEventListener('click', function () {
    var sizeSection = document.getElementById('size');
    if (recommended && window.KoiSize) window.KoiSize.addBag(recommended.id);
    if (sizeSection) {
      if (window.Koi && window.Koi.lenis) window.Koi.lenis.scrollTo(sizeSection, { offset: -70 });
      else sizeSection.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  el.count.value = state.count;
  el.temp.value = state.tempF;
  setTempDisplay();
  render();
})();
